//
import {queryList,getAddPermission, getUpdatePermission, getDeletePermissionList, getAllPageOpList, getResetPageOp, getMenuByClientId} from './../api';
import { Message } from 'element-ui';
const permission = {
    namespaced: true,
    state: {
        successCode:200,
        add:{},
        edit:{},
        view:{},
        dataList:null,
        total:0,
        resp:null,
        addPermission: null,
        updatePermission:null,
        allPageOp:null,
        deletePermission:null,
        resetPageoP:null,
        menuByClientId:null,
      dataPerList:null
    },
    mutations: {
      QUERY_LIST(state,resp){
            state.resp = resp.obj || [];
            state.total = resp.total
        },
      GET_ADD_PERMISSION(state,data){
        state.addPermission = data
      },
      GET_UPDATE_PERMISSION(state,data){
        state.updatePermission = data
      },
      GET_DELETE_PERMISSION(state,data){
        state.deletePermission = data;
      },
      GET_ALL_PAGE_OP(state,data){
        state.allPageOp = data
      },
      GET_RESET_PAGE_OP(state, data){
          state.resetPageoP = data

      },
      GET_MENU_BY_CLIENTID(state,data){
        state.dataPerList = data.obj
        state.menuByClientId = data
      },
    },
    actions: {
       async queryList({commit}, obj){
           let resp = await queryList(obj);
           commit('QUERY_LIST', resp);
        },
        async getAddPermission({commit}, obj){
          let resp = await getAddPermission(obj);
          commit('GET_ADD_PERMISSION', resp);
        },
        async getUpdatePermission({commit}, obj){
          let resp = await getUpdatePermission(obj);
          commit('GET_UPDATE_PERMISSION', resp);
        },
        async getDeletePermission({commit}, obj){
          let resp = await getDeletePermissionList(obj);
          commit('GET_DELETE_PERMISSION', resp);
        },
      async getAllPageOpList({commit}){
        let resp = await getAllPageOpList();
        commit('GET_ALL_PAGE_OP', resp);
      },
      async getResetPageOp({commit}, obj){
        let resp = await getResetPageOp(obj);
        commit('GET_RESET_PAGE_OP', resp);
      },
      async getMenuByClientId({commit},obj){
        let resp = await getMenuByClientId(obj);
        commit('GET_MENU_BY_CLIENTID', resp);
      },
    }
}

export default permission



// WEBPACK FOOTER //
// ./src/page/auth/permission/store/permission.store.js